import React from 'react';
import { Grid, Box } from '@mui/material';
import { ApolloError } from '@apollo/client';

import {
  CircularProgress,
  InfoField,
  Typography,
  LinkChip,
  NO_DATA_PLACEHOLDER,
} from '@occc/ui-design-system';
import { routeCreator as locationRouteCreator } from '@occc-app/routes/Location/utils';
import { LocationFragment } from '@occc/graphql';

export type MemberLocationsProps = {
  locations?: LocationFragment[];
  locationsError?: ApolloError;
  locationsLoading: boolean;
};

export const MemberLocations: React.FC<MemberLocationsProps> = ({
  locations,
  locationsLoading,
  locationsError,
}) => {
  const renderLocationChips = () => {
    if (locationsLoading && !locations) {
      return <CircularProgress />;
    }

    if (locationsError) {
      return <Typography color='error'>Something went wrong. Please try again.</Typography>;
    }

    if (locations?.length) {
      return (
        <Box display='flex' flexDirection='row' flexWrap='wrap' component='span'>
          {locations.map((location) => (
            <LinkChip
              key={location.uuid}
              label={location?.siteSystemConfiguration[0]?.identifier ?? location.uuid}
              href={locationRouteCreator.generalDetails(location.uuid)}
            />
          ))}
        </Box>
      );
    }

    return NO_DATA_PLACEHOLDER;
  };

  return (
    <Grid container>
      <InfoField label='Home Store(s)' disableTypography value={renderLocationChips()} />
    </Grid>
  );
};
